import { useState } from 'react';
import moment from 'moment';
import StripedDataGrid from 'components/Grid/StripedDataGrid';
import EmptyState from 'modules/shared/components/_states/EmptyState/EmptyState';
import LoadingState from 'modules/shared/components/_states/LoadingState/LoadingState';
import EmptyImg from 'assets/img/app_states/empty/result-not-found.png';
import NoFiltersImg from 'assets/img/app_states/empty/no-filters.png';
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import AllocationsFilters from './AllocationsFilters';

const Allocations = props => {
  const columns = [
    { field: 'employeeNo', headerName: 'Employee NO', cellClassName: 'rows', width: 120 },
    {
      field: 'fullName',
      headerName: 'Name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 230,
      cellClassName: 'rows',
      valueGetter: params => `${params.row.firstName || ''} ${params.row.lastName || ''}`
    },
    {
      field: 'email',
      headerName: 'Email',
      cellClassName: 'rows',
      width: 270
    },
    {
      field: 'title',
      headerName: 'Title',
      cellClassName: 'rows',
      width: 220
    },
    {
      field: 'projectName',
      headerName: 'Project Name',
      cellClassName: 'rows',
      width: 230
    },
    {
      field: 'clientName',
      headerName: 'Client Name',
      cellClassName: 'rows',
      width: 250
    },
    {
      field: 'effort',
      headerName: 'Effort',
      cellClassName: 'rows',
      width: 100,
      valueGetter: params => `${params.row.effort + '%'}`
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      cellClassName: 'rows',
      width: 150,
      valueGetter: params => `${moment(params.row.startDate).format('YYYY-MM-DD')}`
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      cellClassName: 'rows',
      width: 150,
      valueGetter: params => `${moment(params.row.endDate).format('YYYY-MM-DD')}`
    }
  ];
  const [filteredColumns, setFilteredColumns] = useState(columns);

  const exportToolbar = () => (
    <GridToolbarContainer className="rightToolbar">
      <GridToolbarExport />
    </GridToolbarContainer>
  );
  const renderDetails = params => {
    return props.navigate(`/employees/${params}/profile`);
  };
  return (
    <div id="EmployeeSkills">
      {!props.isLoading ? (
        <div className="AllocationsEmployeeWrapper">
          <AllocationsFilters
            clients={props.clients}
            clientProjects={props.clientProjects}
            handleChange={props.handleChange}
            dateHandleChange={props.dateHandleChange}
            filterForm={props?.filterForm}
            applyFilter={props?.applyFilter}
            clearFilter={props?.clearFilter}
          />
          {props?.allocations?.length ? (
            <StripedDataGrid
              sortModel={props?.sortModel}
              autoWidth
              rows={props?.allocations}
              columns={filteredColumns}
              onSortModelChange={props?.handleSortChange}
              slots={props?.isFiltered ? { toolbar: exportToolbar } : {}}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                    page: props?.page - 1
                  }
                }
              }}
              pageSizeOptions={[5, 10, 25, 50, 100]}
              disableRowSelectionOnClick
              onRowClick={params => renderDetails(params.row.id)}
              getRowClassName={params =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPaginationModelChange={params => {
                props?.setPage(params?.page + 1);
              }}
            />
          ) : props?.isFiltered ? (
            <EmptyState
              stateImage={
                <div>
                  <img src={EmptyImg} alt="" width={50} style={{ marginTop: '12rem' }} />
                </div>
              }
              stateText={
                <div className="empty-text-section">
                  <div
                    style={{ marginBottom: '0.75em', font: '400 15px/24px "Poppins", sans-serif' }}
                    className="empty-text-message"
                  >
                    No Result found.
                  </div>
                </div>
              }
            />
          ) : (
            <EmptyState
              stateImage={
                <div>
                  <img src={NoFiltersImg} alt="" width={50} style={{ marginTop: '12rem' }} />
                </div>
              }
              stateText={
                <div className="empty-text-section">
                  <div
                    style={{ marginBottom: '0.75em', font: '400 15px/24px "Poppins", sans-serif' }}
                    className="empty-text-message"
                  >
                    No Filters Applied yet.
                  </div>
                </div>
              }
            />
          )}
        </div>
      ) : (
        <LoadingState />
      )}
    </div>
  );
};

export default Allocations;
